import { EventTypeId } from '../types/eventType';
import type {
  FootballLiveEventInfo,
  ScoreboardData,
  TennisLiveEventInfo
} from '../types/scoreboards';

export const isFootballScoreboard = (
  scoreboardData?: ScoreboardData
): scoreboardData is FootballLiveEventInfo => scoreboardData?.eventTypeId === EventTypeId.SOCCER;

export const isTennisScoreboard = (
  scoreboardData?: ScoreboardData
): scoreboardData is TennisLiveEventInfo => scoreboardData?.eventTypeId === EventTypeId.TENNIS;
